<template>
    <div v-if="!loading">
        <v-row class="pa-10 pb-5">
            <v-text-field outlined dense label="Search" @input="searchRma($event)"></v-text-field> &nbsp;
            <v-btn color="primary" @click="downloadRMAs"> Export All RMAs </v-btn>
        </v-row>
        <v-col cols="12" class="ma-0 pa-0">
            <base-divider color="primary" space="3" max-width="100%" />
        </v-col>
        <v-container>
            <v-row class="pa-0 pb-15">
                <v-col cols="2" class="pa-0">
                    <v-select
                        v-model="selectedYear"
                        class="pr-3 pl-3"
                        :items="years"
                        hide-details
                        item-text="text"
                        item-value="value"
                        outlined
                        dense
                        label="Year"
                    ></v-select>
                    <v-navigation-drawer permanent>
                        <v-list dense nav>
                            <v-divider></v-divider>
                            <template v-for="(item, i) in months">
                                <v-list-item
                                    :key="item.text"
                                    link
                                    class="mb-0"
                                    :disabled="
                                        !rmas[selectedYear].items[item.value] ||
                                        !rmas[selectedYear].items[item.value].items
                                    "
                                    @click="selectMonth(item.value)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title
                                            :style="selectedMonth === item.value ? 'color: #db5120' : ''"
                                            >{{ item.text }}</v-list-item-title
                                        >
                                    </v-list-item-content>
                                    <v-spacer></v-spacer>
                                    <v-chip
                                        :color="selectedMonth === item.value ? '#db5120' : ''"
                                        :class="selectedMonth === item.value ? 'white--text' : ''"
                                        label
                                        :disabled="
                                            !rmas[selectedYear].items[item.value] ||
                                            !rmas[selectedYear].items[item.value].items
                                        "
                                        >{{
                                            rmas[selectedYear].items[item.value] &&
                                            rmas[selectedYear].items[item.value].items
                                                ? rmas[selectedYear].items[item.value].items.length
                                                : 0
                                        }}</v-chip
                                    >
                                </v-list-item>
                                <v-divider :key="i" class="ma-0 pa-0"></v-divider>
                            </template>
                        </v-list>
                    </v-navigation-drawer>
                </v-col>
                <v-col cols="10" class="pa-0">
                    <v-data-table
                        :search="search"
                        :items="rmas[selectedYear].items[selectedMonth].items || []"
                        :headers="headers"
                        :loading="loading"
                    >
                        <template v-slot:item.uid="{ item }">
                            <a :data-cy="`link-open-rma-details-${item.uid}`" @click="exposeRmaDetails(item.uid)">{{
                                item.uid
                            }}</a>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <service-details
                ref="serviceDetails"
                :rma-values="singleRmaDetails"
                width="900px"
                @reloadHistory="fetchData"
            />
        </v-container>
    </div>
</template>

<script>
import { fetchRmaData, rmaDetailsByUid } from '@/api'
import ServiceDetails from '../../../rma_history/service_details'
import { cloneDeep } from 'lodash'
import { downloadJsonAsExcel } from '@/utils/excel'
import { dateValueToDate } from '@/utils/format_date'

export default {
    metaInfo: { title: `Your Account`, subTitle: `Dashboard` },
    name: `CdfwRmas`,
    components: { ServiceDetails },
    data() {
        return {
            selectedYear: null,
            years: [],
            search: ``,
            singleRmaDetails: {},
            loading: true,
            rmas: [],
            allRmas: [],
            headers: [
                {
                    text: 'Month',
                    align: 'start',
                    sortable: true,
                    value: 'month_name'
                },

                { text: 'Serial Number', align: 'start', sortable: true, value: 'faulty_device_serial' },
                { text: 'Model', align: 'start', sortable: true, value: 'model' },
                { text: 'Part Number', align: 'start', sortable: true, value: 'pn' },
                { text: 'RMA Number', align: 'start', sortable: true, value: 'uid' },
                { text: 'Order Rcpt Date', align: 'start', sortable: true, value: 'createdat' },
                { text: 'Ship Date', align: 'start', sortable: true, value: 'ship_date' },
                { text: 'Tracking Number', align: 'start', sortable: true, value: 'tracking_number' },
                { text: 'Return Airbill', align: 'start', sortable: true, value: 'return_tracking_number' },
                { text: 'Order TAT', align: 'start', sortable: true, value: 'aes_tat' },
                { text: 'Delivery Date', align: 'start', sortable: true, value: 'delivery_date' },
                { text: 'Ship TAT', align: 'start', sortable: true, value: 'ship_tat' },
                { text: 'Device returned?', align: 'start', sortable: true, value: 'recvd' },
                { text: 'Date Return was Rcvd', align: 'start', sortable: true, value: 'date_received' },
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'uid'
                }
            ],
            selectedMonth: 0,
            months: [
                {
                    text: 'January',
                    value: 0
                },
                {
                    text: 'February',
                    value: 1
                },
                {
                    text: 'March',
                    value: 2
                },
                {
                    text: 'April',
                    value: 3
                },
                {
                    text: 'May',
                    value: 4
                },
                {
                    text: 'June',
                    value: 5
                },
                {
                    text: 'July',
                    value: 6
                },
                {
                    text: 'August',
                    value: 7
                },
                {
                    text: 'September',
                    value: 8
                },
                {
                    text: 'October',
                    value: 9
                },
                {
                    text: 'November',
                    value: 10
                },
                {
                    text: 'December',
                    value: 11
                }
            ]
        }
    },
    computed: {},
    created() {
        this.fetchData()
    },
    methods: {
        searchRma(rma) {
            if (rma === '') this.search = ''
            const found = this.allRmas.find((e) => e.uid === rma)
            if (found) {
                this.selectedMonth = found.month
                this.search = rma
            }
        },

        downloadRMAs() {
            downloadJsonAsExcel(
                `rmas`,
                `rmas`,
                this.allRmas.map((e) => ({
                    Month: e.month_name,
                    'Serial Number': e.faulty_device_serial,
                    Model: e.model,
                    'Part Number': e.pn,
                    'RMA Number': e.uid,
                    'Order Rcpt Date': e.createdat,
                    'Ship Date': e.ship_date,
                    'Address Name': e.ship_company,
                    'Address Line 1': e.line1,
                    'Address Line 2': e.line2,
                    City: e.city,
                    State: e.state,
                    'Postal Code': e.postalcode,
                    'Carrier Type': e.carrier,
                    'Tracking Number': e.tracking_number,
                    'Return Airbill': e.return_tracking_number,
                    'Order TAT': e.aes_tat,
                    'Delivery Date': e.delivery_date,
                    'Ship TAT': e.ship_tat,
                    'Device returned?': e.recvd,
                    'Date Return was Rcvd': e.date_received
                }))
            )
        },

        selectMonth(month) {
            this.search = ''
            this.selectedMonth = month
        },
        groupByMonth(items) {
            const grouped = items.reduce((acc, curr) => {
                const month = curr.month
                let group = acc.find((item) => item.month === month)

                if (!group) {
                    group = {
                        month: month,
                        items: []
                    }
                    acc.push(group)
                }
                group.items.push(curr)

                return acc
            }, [])

            return grouped
        },
        groupByYear(items) {
            const grouped = items.reduce((acc, curr, index) => {
                const year = curr.year
                let group = acc.find((item) => item.year === year)

                if (!group) {
                    group = {
                        year: year,
                        items: []
                    }
                    acc.push(group)
                }
                group.items.push(curr)

                return acc
            }, [])

            return grouped
        },
        async exposeRmaDetails(uid) {
            // const { sortBy, sortDesc, page, itemsPerPage } = this.options
            const { data } = await rmaDetailsByUid({ uid }).catch((e) => ({
                data: {}
            }))
            this.$refs.serviceDetails.isOpen = true
            this.singleRmaDetails = data
        },
        async fetchData() {
            this.$emit('loading', true)
            this.loading = true
            const results = (await fetchRmaData({})).data
            const mapped = results.map((item) => ({
                ...item,
                createdat: dateValueToDate(item.createdat),
                ship_date: dateValueToDate(item.ship_date),
                delivery_date: dateValueToDate(item.delivery_date),
                date_received: dateValueToDate(item.date_received),
                month: item.createdat && item.createdat.value ? new Date(item.createdat.value).getMonth() : '',
                year: item.createdat && item.createdat.value ? new Date(item.createdat.value).getFullYear() : ''
            }))
            this.allRmas = cloneDeep(mapped)

            // group by year then month
            const byYear = this.groupByYear(mapped)
                .sort((a, b) => a.year - b.year)
                .map((e, i) => ({
                    ...e,
                    index: i
                }))
            this.years = byYear.map((e) => ({ text: e.year, value: e.index })).sort((a, b) => a.index - b.index)
            for (let i = 0; i < byYear.length; i++) {
                byYear[i].items = this.groupByMonth(byYear[i].items).sort((a, b) => a.month - b.month)
            }
            this.rmas = byYear

            // select current year
            const currentYear = new Date().getFullYear()
            const foundYear = this.years.find((e) => e.text === currentYear)
            if (foundYear) {
                this.selectedYear = foundYear.value
            }

            this.loading = false
            this.$emit('loading', false)
        }
    }
}
</script>
